import { Formik, getIn, useFormikContext } from "formik";
import React, { MutableRefObject, useContext, useEffect, useRef, useState } from "react";
import { Button, Col, Form, FormCheck, Row } from "react-bootstrap";
import { useIntl } from 'react-intl';
import { toast } from "react-toastify";
import * as Yup from 'yup';
import AutocompleteV2 from "../../../../component/AutocompleteObjectV2";
import LabelRequired from "../../../../component/LabelRequired";
import TextField from "../../../../component/TextField";
import DatePickerCustom from "../../../../component/date-picker/DatePickerCustom";
import ICD10 from "../../../../phan-he-kham-benh/components/ICD10";
import ProvisonalDiagnosis from "../../../../phan-he-kham-benh/components/ProvisonalDiagnosis";
import ModalICD10 from "../../../../phan-he-kham-benh/components/modal-icd10/ModalICD10";
import DynamicModal from "../../../../phan-he-kham-benh/modals/modal-tab-xu-tri/DynamicModal";
import ModalCapNhatThongTinTuVong from "../../../../phan-he-kham-benh/modals/modal-tab-xu-tri/ModalCapNhatThongTinTuVong";
import ChuyenTuyenModal from "../../../../phan-he-kham-benh/modals/modal-tab-xu-tri/modal-chuyen-tuyen/ModalChuyenTuyen";
import ModalRaVien from "../../../../phan-he-kham-benh/modals/modal-tab-xu-tri/modal-ra-vien/ModalRaVien";
import { IDanhSachDanhMuc } from "../../../../phan-he-tiep-nhan-thanh-toan/models/TiepDonModel";
import { APP_TIMESTAMP_FORMAT, CODE, CODE_GENERATE_FORM, KEY_DS_DANH_MUC_TIEP_DON, LEVEL, RESPONSE_MESSAGE } from "../../../../utils/Constant";
import { formatDateDTO, formatDateTime } from "../../../../utils/FormatUtils";
import { getIndexedDBItem } from "../../../../utils/IndexedDB";
import { getListKhoaPhong } from "../../../../utils/ServicesUtils";
import { usePhanHeNoiTruContext } from "../../../PhanHeNoiTruContext";
import { MEDICAL_CONCLUSION_MODALITY_INPATIENT, TREATMENT_TYPE } from "../../../const/PhanHeNoitruConst";
import { cancelTreatmentConclusion, fetchXuTriNoiTru, getDsHinhThucXuTri, getDsKetQuaDieuTri, getThongTinXuTriNoiTru } from "../../../services/HanhChinhServices";
import { AppContext } from "../../../../appContext/AppContext";
import ModalEditOneColumn from "../../../../phan-he-kham-benh/components/modal-ke-thuoc/ModalEditOneColumn";
import { DatLichHenButton } from "../../../../phan-he-kham-benh/components/dat-lich-hen";
import { isValidAppointment } from "../../../../phan-he-kham-benh/components/dat-lich-hen/utils";
import ButtonInPhieu from "../../../../component/button-in-phieu";
import { getAppointmentByVisit, printGiayHenKham } from "../../../../phan-he-kham-benh/services/DatLichHenService";

export type KhamBenh = {
  thongTinKhamBenh?: any;
  setThongTinKhamBenh: ((data: any) => void) | undefined;
};

type Props = {
  handleSubmit: (values: any, workflowCallbackFn?: () => void, cancel?: () => void) => any;
  listHTXT: any;
  listKQ: any;
  setListHTXT: (data: any) => void;
  setModalityDetails: (data: any) => void;
  modalityDetails: any;
  listICD10: any;
  getDetailConclusionFnRef: MutableRefObject<any>;
  listYHCT: any[];
};

export const TabXuTri = (props: Props) => { 
  let {
    handleSubmit,
    listHTXT,
    listKQ,
    setModalityDetails,
    modalityDetails,
    listICD10,
    getDetailConclusionFnRef,
    listYHCT,
  } = props;
  const {
		values,
		setValues,
		setFieldValue,
		errors,
		touched,
		submitForm,
		resetForm,
		initialValues,
  } = useFormikContext<any>();
  const { benhNhanHanhChinh, statusChangedEventFunc } = usePhanHeNoiTruContext();
  const { setIsLoading, isLoading } = useContext(AppContext);

  const [nameComp, setNameComp] = useState<string | undefined>("");
  const [shouldOpenModalICD10, setShouldOpenModalICD10] =
    useState<boolean>(false);
  const [shouldOpenModalSelectICD10, setShouldOpenModalSelectICD10] =
    useState<boolean>(false);
  const [listComorbidity, setListComorbidity] = useState<any[]>([]);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [diagnostic, setDiagnostic] = useState<{
      fieldName: string;
      fieldLabel: string;
      comorbidityField: string;
      comorbidityCodeField: string;
      options: any[];
    }>({
      fieldName: '',
      fieldLabel: '',
      comorbidityField: '',
      comorbidityCodeField: '',
      options: [],
  });

  const isConcluded = benhNhanHanhChinh?.concluded;
  const isCombined = benhNhanHanhChinh?.combined;
  const selectionModeICD10 = 'radio';

  useEffect(() => {
    resetForm();
    if (listKQ.length && listHTXT.length) { 
		getDataXuTri();
	}
  }, [listKQ.length, listHTXT.length, benhNhanHanhChinh?.treatmentId]);

  const getAppointment = async (visitId: string) => {
		try {
			const { code, data } = await getAppointmentByVisit(visitId);			
			if (CODE.SUCCESS === code) {
				setFieldValue('appointment', data);
			}
		} catch (error) {
			console.error(error);
		}
  };

  const handleSelectOption = (option: any, name: string) => {
    setFieldValue(name, option);

    if (!option) return;

    const isHideOptionOpenDialog = option?.attributes?.isOpenDialog === 'f';
    if (isHideOptionOpenDialog) return;

    setNameComp(option?.code);
  };

  const handleCloseModal = () => {
    setNameComp("");
  };

  const convertChuyenTuyenData = (data: any) => {
    return {
      doctorComment: data?.htDoctorInstructions,
      xuTriChuyenTuyen: {
        ...data,
        notes: data?.htNotes,
        chuyenTuyenNguoiChuyen: data?.htPerson,
        treatmentDirection: data?.htTreatmentPlan,
        ketQuaLamSang: data?.htClinicalResults,
        dauHieuLamSang: data?.htClinicalSigns,
        chuyenTuyenThoiGian: formatDateTime(data?.htTime, APP_TIMESTAMP_FORMAT),
        chuyenTuyenTinhTrangBenh: data?.htPatientCondition,
        treatmentMethodApplied: data?.htTreatmentMethod,
        chuyenTuyenVuotTuyen: data?.htOutOfNetwork,
        chuyenTuyenDungTuyen: data?.htInNetwork,
        hospitalName: data?.htHospitalName,
        hospitalCode: data?.htHospitalCode,
        transportVehicle: data?.htTransportation,
        nguoiHoTong: data?.htEscort,
        doctorComment: data?.htDoctorInstructions,

        chuyenTuyenLyDoBacSi: data?.htReasonDoctor,
        chuyenTuyenLyDoBacSiCode: data?.htReasonDoctorCode,
        chuyenTuyenLyDoBacSiChiTiet: data?.htReasonDetails,
        chuyenTuyenLyDo: data?.htReason,
        chuyenTuyenLyDoCode: data?.htReasonCode,
        chuyenTuyenHinhThuc: data?.htModality,
        chuyenTuyenHinhThucCode: data?.htModalityCode,
        chuyenTuyenVisitStartDate: data?.htVisitStartDate,
        chuyenTuyenVisitEndDate: data?.htVisitEndDate,
        chuyenTuyenMucDich: data?.htFor,
        chuyenTuyenMucDichCode: data?.htForCode,
      },
	  [CODE_GENERATE_FORM.xuTriRaVien]: data?.[CODE_GENERATE_FORM.xuTriRaVien],
    };
  }

  const handleSubmitModal = (values: any) => {
    setModalityDetails({
      ...modalityDetails,
      ...values,
    });
    values?.doctorComment && handleChange("doctorComment", values.doctorComment);
    handleCloseModal();
  };

  const compArray = {
    [MEDICAL_CONCLUSION_MODALITY_INPATIENT.CHUYEN_TUYEN.code]: (
      <ChuyenTuyenModal
        open={true}
        xuTriData={values}
        handleCloseModal={() => handleCloseModal()}
        handleSubmit={(data: any) => {
          setValues({
            ...values,
            icdXPrimary: data?.htDiagnosis,
            icdXPrimaryName: data?.htDiagnosisName,
            comorbidity: data?.htComorbidity,
          });
          handleSubmitModal(convertChuyenTuyenData(data));
        }}
        patientInfo={{
          visitId: benhNhanHanhChinh?.visit?.id,
          id: benhNhanHanhChinh?.patient?.patientId,
        }}
      />
    ),
    [MEDICAL_CONCLUSION_MODALITY_INPATIENT.RA_VIEN.code]: (
      <ModalRaVien
        open={true}
        xuTriData={values}
        handleCloseModal={() => {
			setFieldValue('medicalConclusionModality', null);
			handleCloseModal();
		}}
        handleSubmit={(data: any) => {
          setValues({
            ...values,
            icdXPrimary: data?.provisionalDiagnosis,
            icdXPrimaryName: data?.provisionalDiagnosisName,
            comorbidity: data?.comorbidity,
            doctorComment: data?.doctorComment
          });
          handleSubmitModal(data);
        }}
      />
    ),
    [MEDICAL_CONCLUSION_MODALITY_INPATIENT.TU_VONG.code]: (
      <ModalCapNhatThongTinTuVong
        show
        handleCloseDialog={() => {
          handleCloseModal();
        }}
        handleSubmit={(values: any) => handleSubmitModal({
			xuTriTuVong: values
		})}
		patientInfo={benhNhanHanhChinh}
      />
    ),
  };

  const handleChange = (name: string, value: any) => {
    setFieldValue(name, value);
  };

  const getDataXuTri = async () => {
    try {
      if (benhNhanHanhChinh?.treatmentId) {
        let { data } = await getThongTinXuTriNoiTru(benhNhanHanhChinh?.treatmentId);
        if (data?.code === CODE.SUCCESS) {
		  const { data: appointment } = await getAppointmentByVisit(benhNhanHanhChinh?.visitId);

          const medicalConclusion = listKQ?.find((item: any) => {
            return (
              item?.code ===
              data?.data?.medicalConclusionCode
            );
          });

          const medicalConclusionModality = listHTXT?.find(
            (item: any) =>
              item?.code ===
              data?.data?.medicalConclusionModalityCode
          );
          
          switch (data?.data?.medicalConclusionModalityCode) {
            case MEDICAL_CONCLUSION_MODALITY_INPATIENT.CHUYEN_KHOA.code:
              let xuTriChuyenKhoa = data?.data?.xuTriChuyenKhoa;
              setModalityDetails({ xuTriChuyenKhoa })
              break;
            case MEDICAL_CONCLUSION_MODALITY_INPATIENT.RA_VIEN.code:
              let xuTriRaVien = data?.data?.xuTriRaVien;
              setModalityDetails({xuTriRaVien})
              break;
            case MEDICAL_CONCLUSION_MODALITY_INPATIENT.TU_VONG.code:
              let xuTriTuVong = data?.data?.xuTriTuVong;
              setModalityDetails({ xuTriTuVong })
              break;
            default:
              break;
          }
          let xuTriChung = data?.data?.xuTriChung || initialValues?.xuTriChung;
          setValues({
            ...initialValues,
            ...data?.data,
            medicalConclusionDate:
              data?.data?.medicalConclusionDate ||
              formatDateDTO(new Date()),
            medicalConclusionModality,
            medicalConclusion,
            isClinicalTransfer: data?.data?.isClinicalTransfer,
            isConclusion: data?.data?.isConclusion,
            xuTriChung: {
              ...xuTriChung,
              treatmentType: Object.values(TREATMENT_TYPE).find(item => xuTriChung?.[item] === "1")
            },
			appointment,
          });
        }
      }
    } catch (error) {
      console.error(error);
    }
  };
  getDetailConclusionFnRef.current = getDataXuTri;

  const handleChangeICD10 = (data: any) => {
    setValues({
      ...values,
      ...data,
    });
  };

  const cancelConclusion = async (reason: string) => {
    try {
      setIsLoading(true);
      const { code, data } = await cancelTreatmentConclusion(values?.id, {
        reason
      });
      
      if (CODE.SUCCESS !== code) {
        const message = data?.[0]?.errorMessage || RESPONSE_MESSAGE.ERROR;
        toast.warn(message);
        return;
      }

      toast.success('Hủy xử trí thành công');
      statusChangedEventFunc();
      resetForm({
        values: initialValues
      });
    } catch (error) {
      console.error(error);
      toast.error(RESPONSE_MESSAGE.ERROR);
    } finally {
      setIsLoading(false);
    }
  };

  return (
		<Form>
			<div className="spaces h-calc-vh-200 border-bottom bg-white overflow-y-auto px-8 pt-8">
				<Row className="mb-1 pt-5">
					<Col xs={4} className="spaces mt-1">
						<div className="mb-3">
							<div className="d-flex justify-content-between mb-1">
								<LabelRequired label="Chẩn đoán xác định" />
							</div>

							<TextField
								as="textarea"
								rows={2}
								name="finalDiagnosis"
								value={values?.finalDiagnosis || ''}
								disabled={isConcluded}
								onChange={(e: any) =>
									handleChange('finalDiagnosis', e.target.value)
								}
							/>
						</div>

						<div className="mb-2">
							<div className="d-flex mb-1">
								<LabelRequired
									label="Nguyên nhân - ICD10"
									className="min-w-150px"
								/>
							</div>
							<TextField
								as="textarea"
								rows={2}
								name="icdXCause"
								disabled={isConcluded}
								value={values?.icdXCause || ''}
								onChange={(e: any) => handleChange('icdXCause', e.target.value)}
							/>
						</div>

						<div className="d-flex gap-2 mb-2">
							<div className="flex-1 w-49">
								<div className="d-flex">
									<LabelRequired label="Thời gian xử trí" isRequired />
								</div>
								<DatePickerCustom
									mode="date-time"
									name="medicalConclusionDate"
									value={values?.medicalConclusionDate}
									setDateValue={(date) =>
										handleChange('medicalConclusionDate', date)
									}
									errors={errors.medicalConclusionDate}
									touched={touched.medicalConclusionDate}
									disabled={isConcluded}
								/>
							</div>
							<div className="flex-1">
								<div className="d-flex">
									<LabelRequired label="Kết quả điều trị" isRequired/>
								</div>
								<AutocompleteV2
									options={listKQ || []}
									name="medicalConclusion"
									value={values?.medicalConclusion}
									isDisabled={isConcluded}
									onChange={(option) =>
										setFieldValue('medicalConclusion', option)
									}
									errors={getIn(errors, 'medicalConclusion')}
									touched={getIn(touched, 'medicalConclusion')}
								/>
							</div>
						</div>
						<div className="d-flex gap-2">
							<div className="spaces width-49">
								<div className="d-flex">
									<LabelRequired label="Hình thức xử trí" isRequired />
								</div>
								<AutocompleteV2
									options={listHTXT || []}
									name="medicalConclusionModality"
									isDisabled={isConcluded}
									value={values?.medicalConclusionModality}
									onChange={(option) => {
										setModalityDetails({});
										handleSelectOption(option, 'medicalConclusionModality');
										setFieldValue('medicalConclusionModality', option);
									}}
									errors={getIn(errors, 'medicalConclusionModality')}
									touched={getIn(touched, 'medicalConclusionModality')}
								/>
							</div>
							{values?.medicalConclusionModality?.code ===
								MEDICAL_CONCLUSION_MODALITY_INPATIENT.CHUYEN_KHOA.code && (
								<div className="flex-1">
									<div className="d-flex">
										<LabelRequired label="Tên khoa" />
									</div>
									<AutocompleteV2
										options={[]}
										searchFunction={getListKhoaPhong}
										searchObject={{ level: LEVEL.KHOA }}
										getOptionLabel={(option: any) =>
											`${option.code} - ${option.name}`
										}
										name="xuTriChuyenKhoa"
										value={
											modalityDetails?.xuTriChuyenKhoa?.toDeptId
												? {
														id: modalityDetails?.xuTriChuyenKhoa
															?.toDeptId,
														code: modalityDetails?.xuTriChuyenKhoa
															?.toDeptCode,
														name: modalityDetails?.xuTriChuyenKhoa
															?.toDeptName,
												  }
												: null
										}
										onChange={(option) => {
											setModalityDetails({
												xuTriChuyenKhoa: {
													toDeptId: option?.id,
													toDeptCode: option?.code,
													toDeptName: option?.name,
												},
											});
										}}
										isDisabled={isConcluded}
									/>
								</div>
							)}
						</div>
						<div className="spaces mt-15 mb-10 d-flex flex-wrap w-100">
							<FormCheck
								className="ms-1 me-3 mt-2 spaces min-w-100"
								label="Thủ thuật"
								type="checkbox"
								name="raVienThuThuat"
								checked={values?.xuTriChung?.raVienThuThuat === '1'}
								onChange={(e) =>
									setFieldValue(
										'xuTriChung.raVienThuThuat',
										e.target.checked ? '1' : '0'
									)
								}
								disabled={isConcluded}
							/>
							<FormCheck
								className="ms-1 me-3 mt-2 spaces min-w-100"
								label="Phẫu thuật"
								type="checkbox"
								name="raVienPhauThuat"
								checked={values?.xuTriChung?.raVienPhauThuat === '1'}
								onChange={(e) =>
									setFieldValue(
										'xuTriChung.raVienPhauThuat',
										e.target.checked ? '1' : '0'
									)
								}
								disabled={isConcluded}
							/>
							<FormCheck
								className="ms-1 me-3 mt-2 spaces min-w-100"
								label="Tai biến"
								type="checkbox"
								name="raVienTaiBien"
								checked={values?.xuTriChung?.raVienTaiBien === '1'}
								onChange={(e) =>
									setFieldValue(
										'xuTriChung.raVienTaiBien',
										e.target.checked ? '1' : '0'
									)
								}
								disabled={isConcluded}
							/>
							<FormCheck
								className="ms-1 me-3 mt-2 spaces min-w-100"
								label="Biến chứng"
								type="checkbox"
								name="raVienBienChung"
								checked={values?.xuTriChung?.raVienBienChung === '1'}
								onChange={(e) =>
									setFieldValue(
										'xuTriChung.raVienBienChung',
										e.target.checked ? '1' : '0'
									)
								}
								disabled={isConcluded}
							/>
						</div>
						<div className="spaces mt-15 mb-10 d-flex flex-wrap w-100">
							<FormCheck
								className="ms-1 me-3 mt-2 spaces min-w-100"
								label="Nội trú"
								type="radio"
								name="treatmentType"
								value={TREATMENT_TYPE.RA_VIEN_NOI_TRU}
								checked={
									values?.xuTriChung?.treatmentType ===
									TREATMENT_TYPE.RA_VIEN_NOI_TRU
								}
								onChange={(e) =>
									setFieldValue('xuTriChung.treatmentType', e.target.value)
								}
								disabled={isConcluded}
							/>
							<FormCheck
								className="ms-1 me-3 mt-2 spaces min-w-100"
								label="Nội trú ban ngày"
								type="radio"
								name="treatmentType"
								value={TREATMENT_TYPE.RA_VIEN_NOI_TRU_BAN_NGAY}
								checked={
									values?.xuTriChung?.treatmentType ===
									TREATMENT_TYPE.RA_VIEN_NOI_TRU_BAN_NGAY
								}
								onChange={(e) =>
									setFieldValue('xuTriChung.treatmentType', e.target.value)
								}
								disabled={isConcluded}
							/>
							<FormCheck
								className="ms-1 me-3 mt-2 spaces min-w-100"
								label="Ngoại trú"
								type="radio"
								name="treatmentType"
								value={TREATMENT_TYPE.RA_VIEN_NGOAI_TRU}
								checked={
									values?.xuTriChung?.treatmentType ===
									TREATMENT_TYPE.RA_VIEN_NGOAI_TRU
								}
								onChange={(e) =>
									setFieldValue('xuTriChung.treatmentType', e.target.value)
								}
								disabled={isConcluded}
							/>
						</div>
					</Col>

					<Col xs={8} className="ps-0">
						<div className="mb-2">
							<div className="d-flex justify-content-between">
								<LabelRequired
									label="Bệnh chính - ICD10"
									className="min-w-150px"
									isRequired
								/>
								{!isConcluded && (
									<Button
										className="bg-white spaces pr-1 py-0"
										onClick={() => {
											setDiagnostic({
												fieldName: 'icdXPrimary',
												fieldLabel: 'ICD10',
												options: listICD10,
												comorbidityField: 'comorbidity',
												comorbidityCodeField: 'comorbidityCode',
											});
											setShouldOpenModalSelectICD10(true);
										}}
									>
										<u className="link-info">Chọn bệnh</u>
									</Button>
								)}
							</div>
							<Row className="spaces pe-0 align-items-center position-relative">
								<ProvisonalDiagnosis
									encounterDiagnosisValues={values}
									encounterDiagnosisErrors={errors}
									encounterDiagnosisTouched={touched}
									listComorbidity={listComorbidity}
									setListComorbidity={setListComorbidity}
									disabled={isConcluded}
									icd10Field="icdXPrimary"
									onChange={handleChangeICD10}
									handleChangeEncounterDiagnosis={handleChange}
								/>
							</Row>
						</div>

						<div className="mb-2">
							<div className="spaces d-flex flex-row justify-content-between">
								<div className="d-flex">
									<LabelRequired
										label="Bệnh kèm theo - ICD10"
										className="min-w-150px"
									/>
								</div>
							</div>
							<Row className="spaces pe-0 align-items-center">
								<TextField
									name="comorbidity"
									as="textarea"
									rows={2}
									value={values?.comorbidity || ''}
									disabled={isConcluded}
                  					readOnly
								/>
							</Row>
						</div>
						<div className="mb-2">
							<div className="d-flex justify-content-between">
								<LabelRequired label="Bệnh chính - YHCT" className="min-w-150px" />
								{!isConcluded && (
									<Button
										className="bg-white spaces pr-1 py-0"
										onClick={() => {
											setDiagnostic({
												fieldName: 'yhctPrimary',
												fieldLabel: 'YHCT',
												options: listYHCT,
												comorbidityField: 'yhctComorbidity',
												comorbidityCodeField: 'yhctComorbidityCode',
											});
											setShouldOpenModalSelectICD10(true);
										}}
									>
										<u className="link-info">Chọn bệnh</u>
									</Button>
								)}
							</div>
							<Row className="spaces pe-0 align-items-center position-relative">
								<ProvisonalDiagnosis
									encounterDiagnosisValues={values}
									encounterDiagnosisErrors={errors}
									encounterDiagnosisTouched={touched}
									listComorbidity={listComorbidity}
									setListComorbidity={setListComorbidity}
									icd10Field="yhctPrimary"
									onChange={handleChangeICD10}
									handleChangeEncounterDiagnosis={()=>{}}
									comorbidityField="yhctComorbidity"
									comorbidityCodeField="yhctComorbidityCode"
									fieldLabel="YHCT"
									diagnosisList={listYHCT}
									hasDiagnosisNonCoded={false}
								/>
							</Row>
						</div>

						<div>
							<div className="spaces d-flex flex-row justify-content-between">
								<div className="d-flex ">
									<LabelRequired
										label="Bệnh kèm theo - YHCT"
										className="min-w-150px"
									/>
								</div>
							</div>
							<Row className="spaces pe-0 align-items-center">
								<TextField
									name="yhctComorbidity"
									as="textarea"
									rows={2}
									value={values?.yhctComorbidity || ''}
                  					readOnly
								/>
							</Row>
						</div>
					</Col>
				</Row>
				<Row>
					<Col xs={12} className="spaces mt-1">
						<div>
							<div className="d-flex mb-1">
								<LabelRequired label="Lời dặn của bác sĩ" className="min-w-150px" />
							</div>
							<TextField
								as="textarea"
								rows={2}
								name="doctorComment"
								value={values?.doctorComment || ''}
								disabled={isConcluded}
								onChange={(e: any) => handleChange('doctorComment', e.target.value)}
								errors={getIn(errors, 'doctorComment')}
								touched={getIn(touched, 'doctorComment')}
							/>
						</div>
					</Col>
					<Col xs={4} className="spaces mt-8">
						<DatePickerCustom
							label="Thời gian hẹn khám lại"
							labelClassName="spaces min-w-155"
							name="appointmentDate"
							value={
								isValidAppointment(values?.appointment)
									? values?.appointment?.scheduledDate
									: null
							}
							mode="date-time"
							disabled
						/>
					</Col>
				</Row>
				<Row className="position-fixed bottom-0 w-100 bg-white py-2">
					<Col xs="12" className="d-flex gap-2">
						{isValidAppointment(values?.appointment) && (
								<ButtonInPhieu
									fetchExport={printGiayHenKham}
									params={{
										fileType: 'pdf',
										id: values?.appointment?.id,
									}}
									label="In giấy hẹn khám lại"
									className="spaces px-16"
								/>
							)}

						{benhNhanHanhChinh?.treatmentId && (
							<>
								{!isConcluded && (
									<>
										<DatLichHenButton
											patientInfo={{
												...benhNhanHanhChinh,
												patient: {
													...benhNhanHanhChinh?.patient,
													personName: benhNhanHanhChinh?.patientName,
													code: benhNhanHanhChinh?.patientCode,
												},
											}}
											itemEdit={values?.appointment}
											onSuccess={() => {
												getAppointment(benhNhanHanhChinh?.visitId);
											}}	
										/>
										<Button
											className="btn-fill min-w-80px"
											onClick={() => submitForm()}
											disabled={isLoading}
										>
											{isCombined ? 'Kết thúc điều trị' : 'Lưu'}
										</Button>
									</>
								)}

								{isConcluded && values?.isCancelable && (
									<Button
										className="btn-fill min-w-80px"
										onClick={() => {
											setOpenConfirmDialog(true);
										}}
									>
										{isCombined ? 'Hủy kết thúc điều trị' : 'Hủy xử trí'}
									</Button>
								)}
							</>
						)}
					</Col>
				</Row>
			</div>

			<DynamicModal compArray={compArray} nameComp={nameComp} />

			<ICD10
				shouldOpenModalICD10={shouldOpenModalICD10}
				setShouldOpenModalICD10={setShouldOpenModalICD10}
				shouldOpenModalSelectICD10={shouldOpenModalSelectICD10}
				setShouldOpenModalSelectICD10={setShouldOpenModalSelectICD10}
				listComorbidity={listComorbidity}
				setListComorbidity={setListComorbidity}
				selectionModeICD10={selectionModeICD10}
				data={values}
				onChange={handleChangeICD10}
				listICD10={diagnostic.options}
				icd10Field={diagnostic.fieldName}
				fieldLabel={diagnostic.fieldLabel}
				comorbidityField={diagnostic.comorbidityField}
				comorbidityCodeField={diagnostic.comorbidityCodeField}
			/>

			{openConfirmDialog && (
				<ModalEditOneColumn
					name="Lý do hủy"
					code="reason"
					handleClose={() => setOpenConfirmDialog(false)}
					handleSave={(value: any) => cancelConclusion(value.reason)}
				/>
			)}
		</Form>
  );
};

const XuTri = () => {
  const { benhNhanHanhChinh, statusChangedEventFunc } = usePhanHeNoiTruContext();
  const { setIsLoading } = useContext(AppContext);
  const intl = useIntl();

  const [listHTXT, setListHTXT] = useState<any[]>([]);
  const [listKQ, setListKQ] = useState<any[]>([]);
  const [modalityDetails, setModalityDetails] = useState<any>({});
  const [listICD10, setListICD10] = useState<any>([]);
  const [listYHCT, setListYHCT] = useState<any[]>([]);

  const formRef = useRef<any>(null);
  const getDetailConclusionFnRef = useRef<any>(null);

  const validationSchema = Yup.object({
		icdXPrimary: Yup.string()
			.required(intl.formatMessage({ id: 'VALIDATION.REQUIRE' }))
			.nullable(),
		medicalConclusionModality: Yup.mixed().required(
			intl.formatMessage({ id: 'VALIDATION.REQUIRE' })
		),
		medicalConclusionDate: Yup.mixed().required(
			intl.formatMessage({ id: 'VALIDATION.REQUIRE' })
		),
		medicalConclusion: Yup.mixed().required(
			intl.formatMessage({ id: 'VALIDATION.REQUIRE' })
		),
  });

  const initialValues = {
    medicalConclusionModality: null,
    medicalConclusionDate: formatDateTime(
      new Date(),
      APP_TIMESTAMP_FORMAT
    ),
    icdXPrimary: null,
    xuTriChung: {
      raVienNgoaiTru: '0',
      raVienTaiBien: '0',
      raVienNoiTru: '0',
      raVienThuThuat: '0',
      raVienBienChung: '0',
      raVienNgay: '0',
      raVienNoiTruBanNgay: '0'
    }
  };

  useEffect(() => {
    handleGetDanhMuc();
  }, []);

  const handleSubmitXuTri = async (values: any) => {
    try {
      let submitData = {
        ...values,
        medicalConclusionCode: values?.medicalConclusion?.code,
        medicalConclusionName: values?.medicalConclusion?.name,
        medicalConclusionModalityCode: values?.medicalConclusionModality?.code,
        medicalConclusionModalityName: values?.medicalConclusionModality?.name,
        xuTriChung: {
          ...values?.xuTriChung,
          [values?.xuTriChung?.treatmentType]: "1",
        },
        ...modalityDetails,
        patientId: benhNhanHanhChinh?.patientId,
        treatmentId: benhNhanHanhChinh?.treatmentId,
      };
      delete submitData?.medicalConclusionModality;
      delete submitData?.medicalConclusion;
      delete submitData?.xuTriChung?.treatmentType;

	  setIsLoading(true);
      let { data } = await fetchXuTriNoiTru(submitData);
      if (CODE.SUCCESS === data.code) {
        toast.success("Thành Công");
        statusChangedEventFunc();
        getDetailConclusionFnRef.current();
      } else {
        let errorMessage =
          data?.data?.[0]?.errorMessage || RESPONSE_MESSAGE.ERROR;
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error(error);
      toast.error(RESPONSE_MESSAGE.ERROR);
    } finally {
		setIsLoading(false);
	}
  };

  const handleGetDanhMuc = async () => {
    try {
      let res: IDanhSachDanhMuc = await getIndexedDBItem(
        KEY_DS_DANH_MUC_TIEP_DON
      );
      let { data: ketQuaDieuTri } = await getDsKetQuaDieuTri();
      let { data: hinhThucXuTri } = await getDsHinhThucXuTri();
      setListICD10(res?.listICD10 || []);
      setListHTXT(hinhThucXuTri?.data || []);
      setListKQ(ketQuaDieuTri?.data || []);
      setListYHCT(res?.listYHocCoTruyen);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmitXuTri}
      validationSchema={validationSchema}
      innerRef={formRef}
    >
      <div>
        <TabXuTri
          listHTXT={listHTXT}
          setListHTXT={setListHTXT}
          listKQ={listKQ}
          setModalityDetails={setModalityDetails}
          modalityDetails={modalityDetails}
          listICD10={listICD10}
          handleSubmit={handleSubmitXuTri}
          getDetailConclusionFnRef={getDetailConclusionFnRef}
          listYHCT={listYHCT}
        />
      </div>
    </Formik>
  );
};

export default XuTri;
